module.exports = __webpack_public_path__ + "media/icons/add-item@3x-7560bdbc.svg";